import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import CenterHeader from 'components/center/CenterHeader';
import { ManagerItems } from 'constant';
import useTabs from 'hooks/useTabs';
import { login } from 'services/api-service/center';
import { IStoreState } from 'store/modules';
import ManagerDispatch from './ManagerDispatch';
import ManagerPasswordCheck from './ManagerPasswordCheck';
import ManagerRescue from './ManagerRescue';
import ManagerStatistics from './ManagerStatistics';
import ManagerUser from './ManagerUser';
import Menus from './Menus';

const ManagerTemplate = () => {
  const userInfo = useSelector((store: IStoreState) => store.UserReducer.userInfo);
  const { contentItem, contentChange } = useTabs(0, ManagerItems);
  const [isAuth, setIsAuth] = useState(false);

  const authRequiredTabs = [2, 3];

  const handleTabChange = (index: number) => {
    if (authRequiredTabs.includes(index)) {
      setIsAuth(false);
    }
    contentChange(index);
  };

  const handlePasswordConfirm = async (password: string) => {
    try {
      const response: any = await login(userInfo.userId, password);

      if (response.result === 'success') {
        setIsAuth(true);
      } else {
        toast.error('비밀번호가 일치하지 않습니다.');
      }
    } catch (error) {
      console.error('Password Verification Error:', error);
      toast.error('인증 중 오류가 발생했습니다.');
    }
  };

  const ActiveTab = () => {
    if (authRequiredTabs.includes(contentItem.index) && !isAuth) {
      return <ManagerPasswordCheck onConfirm={handlePasswordConfirm} />;
    }
    switch (contentItem.index) {
      case 1:
        return <ManagerDispatch />;
      case 2:
        return <ManagerRescue userInfo={userInfo} />;
      case 3:
        return <ManagerUser userInfo={userInfo} />;
      case 0:
      default:
        return <ManagerStatistics />;
    }
  };

  useEffect(() => {
    //
  }, []);

  return (
    <ManagerTemplateWrap>
      <CenterHeader
        title="스마트 수색구조시스템"
        userinfo={userInfo}
        onInitialize={() => null}
        onWarning={() => null}
        isCenter={false}
      ></CenterHeader>
      <ManagerWrap>
        <Menus current={contentItem.index} menus={ManagerItems} onClick={handleTabChange} />
        <DisplayWrap>{ActiveTab()}</DisplayWrap>
      </ManagerWrap>
    </ManagerTemplateWrap>
  );
};

const ManagerTemplateWrap = styled.div`
  width: 100%;
  height: 100%;
`;
const ManagerWrap = styled.div`
  position: absolute;
  top: 3.75rem;
  height: calc(100% - 3.75rem);
  min-height: 63.75rem;
  display: flex;
`;
const DisplayWrap = styled.div`
  width: calc(100vw - 25rem);
  background: #00315c;
`;

export default ManagerTemplate;
